import React from 'react';
import { Image } from 'antd';
import * as MaterialProgramTip from '../MaterialProgramTip';
import { TooltipStyles } from '../../Tooltip.styles';
import {
    DivFlexWithWrap,
    DivImpactArea,
    DivImpactAreaImage,
    DivImpactAreaName,
    IaLegend
} from '../../dtImpactAreasTip/DtImpactAreasTip.styles';
import { BoldText } from '../../../../../../../styles/common.styles';

const LPCTip: React.FC = () => {

    const allImpactAreas = [
        'Human Health',
        'Climate Health',
        'Circular Economy',
        'Social Health & Equity',
        'Ecosystem Health'
    ];

    const getInspectAreaImage = (impactAreaName : string) => {
        switch(impactAreaName) {
           case 'HUMAN HEALTH':
               return 'src/assets/images/health_red_notext.svg';
           case 'CLIMATE HEALTH':
               return 'src/assets/images/climate_blue_notext.svg';
           case 'CIRCULAR ECONOMY':
               return 'src/assets/images/circularity_blue_notext.svg';
           case 'SOCIAL HEALTH & EQUITY':
               return 'src/assets/images/social_purple_notext.svg';
           case 'ECOSYSTEM HEALTH':
               return 'src/assets/images/ecosystem_green_notext.svg';
            default:
                return '';
        }
     };

    return (
        <MaterialProgramTip.Container>
            <TooltipStyles className="shadow" style={{width: 317+'px'}}>
                <div className="tooltip tooltip-cmf">
                    <h1>Living Product Challange Certification</h1>
                    <h2>Program</h2>
                    <p>
                        The Living Product Challenge (LPC) is a philosophy first, an
                        advocacy tool second and a certification program third. The
                        Challenge is a framework for manufacturers to create
                        products that are healthy, inspirational and give back to the
                        environment.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <img src="src/assets/images/verified.png" alt="" />{' '}
                        <b>Living Product label has been 3rd party verified.</b>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <b>LPC 3rd party verifiers:</b> A Greener Space, Green Start,
                            GreenCircle, SCS, Sustainability Made Simple, Vertima, WAP
                            Sustainability.{' '}
                    </p>
                    <h2>Results</h2>
                    <div className="tooltip-content">
                        <div className="tooltip-row">
                            <p>
                                <strong>Imperative Certified:</strong> The product has imperative certification
                                    which requires that, at minimum, the seven Core Imperatives
                                    are attained, representing a significant and holistic
                                    achievement that companies can build on to achieve higher
                                    levels of certification.
                            </p>
                        </div>
                        <div className="tooltip-row">
                            <p>
                                <strong>Petal Certified:</strong> The product has petal certification which
                                    requires achievement of the Core Imperatives and at least
                                    three of the seven Petals, one of which must be the Water,
                                    Energy, or Materials Petal.
                            </p>
                        </div>
                        <div className="tooltip-row">
                            <p>
                                <strong>Living Certified:</strong> The product is full living product certified
                                    which requires the achievement of all 20 Imperatives,
                                    signaling that the product has become truly regenerative
                                    across all impact areas and can be counted among the most
                                    sustainable in the world.
                            </p>
                        </div>
                    </div>
                    <p>
                        <a
                            href="https://living-future.org/lpc/"
                            target="_blank">
                            Visit the Living Product Challenge website to learn more.
                        </a>
                    </p>

                    <IaLegend className='legend-lpc'>

                        <BoldText
                            size={12}
                            height={14}
                            color={'#00237B'}
                            weight={400}
                            className='cmf-impact-area-label'
                        >
                                This document is identified in the following Common Materials Framework (CMF) impact areas:
                        </BoldText>

                        <DivFlexWithWrap>
                            {allImpactAreas?.map((impactArea) => (
                                <DivImpactArea key={impactArea?.toUpperCase()}>
                                    <DivImpactAreaImage>
                                        <Image
                                            preview={false}
                                            src={getInspectAreaImage(impactArea?.toUpperCase())}
                                            style={{ cursor: 'none' }}
                                            width={22} height={22}
                                        />
                                    </DivImpactAreaImage>
                                    <DivImpactAreaName>
                                        {impactArea}
                                    </DivImpactAreaName>
                                </DivImpactArea>
                            ))}
                        </DivFlexWithWrap>
                    </IaLegend>
                </div>
            </TooltipStyles>
        </MaterialProgramTip.Container>
    );
};

export default LPCTip;
